var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"page-login-video-stream-alternative-hint",domProps:{"textContent":_vm._s(_vm.$tt('or_enter_login_password'))}})}
var staticRenderFns = []

export { render, staticRenderFns }